import { jUserLittle, WidgetLegacyMixedBoolean } from 'jamespot-user-api';
import React, { useMemo } from 'react';

import styled from 'styled-components';

import { JRCProgressBar } from '../../JRCProgressBar/JRCProgressBar';
import { Typography } from '../../JRCTypography/JRCTypography.styles';

import { WidgetAvatarList } from '../components/WidgetAvatarList';

const CSSWidgetQuickSurveyResponseProgressBarWithUser = styled.div<{ isClosed?: boolean }>`
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.space.sm}px;
    width: 100%;
    flex: 1;
    cursor: ${(props) => (props.isClosed ? 'default' : 'pointer')};
`;

const CSSQuickSurveyListItemBtn = styled.button`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.space.sm}px;
`;

export const JRCWidgetQuickSurveyResponse = ({
    anonymize,
    limit,
    userResponses,
    canSeeResponses,
    isClosed,
    setOpenUsersModal,
    handleResponseClick,
}: {
    anonymize?: WidgetLegacyMixedBoolean;
    limit: number;
    userResponses: { counter: number; userList: jUserLittle[] };
    canSeeResponses?: WidgetLegacyMixedBoolean;
    isClosed?: WidgetLegacyMixedBoolean;
    setOpenUsersModal: () => void;
    handleResponseClick: () => void;
}) => {
    const leftCount = useMemo(() => {
        if (!userResponses.userList) return 0;
        if (userResponses.counter && userResponses.counter > userResponses.userList.length) {
            return userResponses.counter - userResponses.userList.length;
        }

        return 0;
    }, [userResponses]);

    return (
        <>
            <CSSWidgetQuickSurveyResponseProgressBarWithUser isClosed={!!isClosed}>
                <CSSQuickSurveyListItemBtn onClick={handleResponseClick}>
                    <JRCProgressBar value={userResponses.counter ?? 0} total={limit} colorProgressBar="orange" />
                </CSSQuickSurveyListItemBtn>

                {!!(userResponses.counter > 0) && !!canSeeResponses && (
                    <Typography size={'s'}>{Math.trunc(((userResponses.counter ?? 0) / limit) * 100)}%</Typography>
                )}
            </CSSWidgetQuickSurveyResponseProgressBarWithUser>
            {!anonymize && canSeeResponses && (
                <div onClick={() => canSeeResponses && setOpenUsersModal()}>
                    <WidgetAvatarList list={userResponses.userList} left={leftCount} />
                </div>
            )}
        </>
    );
};
